module.exports = __webpack_public_path__ + "img/kerberos.2dc301c1.svg";